import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { supabase } from '../supabaseClient';

export default function ProtectedRoute({ children }) {
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState(null);
  const location = useLocation();

  useEffect(() => {
    let isMounted = true;
    
    async function checkUser() {
      try {
        const { data: { session }, error } = await supabase.auth.getSession();
        
        if (error) {
          console.error("Session error:", error);
          if (isMounted) setUser(null);
        } else if (session && session.user) {
          if (isMounted) setUser(session.user);
        } else {
          if (isMounted) setUser(null);
        }
      } catch (error) {
        console.error("Error checking auth:", error);
        if (isMounted) setUser(null);
      } finally {
        if (isMounted) setLoading(false);
      }
    }
    
    checkUser();
    
    return () => {
      isMounted = false;
    };
  }, []);

  if (loading) {
    return <div className="loading-container">
      <span className="spinner"></span>
      <p>Checking authentication status...</p>
    </div>;
  }
  
  if (!user) {
    // If not logged in, redirect to login page
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }

  // User is authenticated, render the protected component
  return children;
} 